import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function hexToRgb(hex) {
  const h = (hex || "#0F172A").replace("#", "");
  return { r: parseInt(h.substring(0, 2), 16), g: parseInt(h.substring(2, 4), 16), b: parseInt(h.substring(4, 6), 16) };
}

const fmt = (n) => "$ " + Math.round(n).toLocaleString("es-AR");

// Documento PDF de ejemplo genérico (contrato, garantía, recibo, presupuesto).
export function generarDocumentoPDF({ titulo, subtitulo, lineas = [], agencia, color, nombreArchivo }) {
  const doc = new jsPDF();
  const rgb = hexToRgb(color);
  doc.setFillColor(rgb.r, rgb.g, rgb.b);
  doc.rect(0, 0, 210, 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(agencia || "Inmobiliaria", 14, 12);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(titulo, 14, 20);

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(11);
  if (subtitulo) doc.text(subtitulo, 14, 36);

  let y = subtitulo ? 46 : 40;
  doc.setFontSize(10);
  lineas.forEach((l) => {
    doc.text(String(l), 14, y);
    y += 7;
  });

  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text("Documento de ejemplo generado por la demo. Los datos son ficticios.", 14, 285);

  doc.save(nombreArchivo || "documento.pdf");
}

// Acta de entrega / salida (PDF de ejemplo con inventario y medidores).
export function generarActaPDF({ tipo, contrato, detalle, agencia, color }) {
  const doc = new jsPDF();
  const rgb = hexToRgb(color);
  const titulo = tipo === "salida" ? "Acta de salida" : "Acta de entrega (entrada)";

  doc.setFillColor(rgb.r, rgb.g, rgb.b);
  doc.rect(0, 0, 210, 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(agencia || "Inmobiliaria", 14, 12);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(titulo, 14, 20);

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(11);
  doc.text(`Propiedad: ${contrato.direccion}`, 14, 38);
  doc.text(`Inquilino: ${contrato.inquilino.nombre}   ·   Propietario: ${contrato.propietario.nombre}`, 14, 45);
  doc.text(`Fecha: ${new Date().toLocaleDateString("es-AR")}`, 14, 52);

  doc.text(`Llaves entregadas: ${detalle.checkin.llaves} juegos`, 14, 64);
  doc.text(
    `Medidores — Luz: ${detalle.checkin.medidores.luz} · Gas: ${detalle.checkin.medidores.gas} · Agua: ${detalle.checkin.medidores.agua}`,
    14,
    71
  );

  const filas = detalle.checkin.inventario.flatMap((inv) => inv.items.map((it) => [inv.ambiente, it.item, it.estado]));
  autoTable(doc, {
    startY: 78,
    head: [["Ambiente", "Ítem", "Estado"]],
    body: filas,
    theme: "grid",
    headStyles: { fillColor: [rgb.r, rgb.g, rgb.b], textColor: 255 },
    styles: { fontSize: 9, cellPadding: 2.5 },
  });

  const y = doc.lastAutoTable.finalY + 20;
  doc.setFontSize(10);
  doc.text("Firma del inquilino: ____________________", 14, y);
  doc.text("Firma del agente: ______________________", 110, y);

  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text("Documento de ejemplo generado por la demo. Los datos son ficticios.", 14, 285);

  doc.save(`acta-${tipo}-${contrato.id}.pdf`);
}

export { fmt as fmtPesos };
